<template>
  <div>
    <page-table :orderCode="orderCode" :disabled="disabled" />
  </div>
</template>
<script>
import PageTable from "./components/table"
export default {
  props: {
    orderCode: String,
    disabled: { type: Boolean, default: false },
  },
  components: { PageTable },
}
</script>
